export function activityDate(a) {
    return a.start.slice(0, 10);
}
export function activityTime(a) {
    if (a.allDay || a.start.length < 16)
        return "";
    return a.start.slice(11, 16);
}
export function activityTimeRange(a) {
    const start = activityTime(a);
    if (!start)
        return "";
    const end = a.end && !a.allDay && a.end.length >= 16 ? a.end.slice(11, 16) : "";
    if (!end || (a.end && a.end.slice(0, 10) !== activityDate(a)))
        return start;
    return `${start}–${end}`;
}
export function activitiesOn(activities, date) {
    return activities
        .filter((a) => activityDate(a) === date)
        .sort((a, b) => a.start.localeCompare(b.start));
}
export function countsByDate(activities) {
    var _a;
    const out = {};
    for (const a of activities) {
        const d = activityDate(a);
        out[d] = ((_a = out[d]) !== null && _a !== void 0 ? _a : 0) + 1;
    }
    return out;
}
export function isFinished(a, now = new Date()) {
    var _a;
    if (a.allDay)
        return false;
    const at = Date.parse((_a = a.end) !== null && _a !== void 0 ? _a : a.start);
    return Number.isNaN(at) ? false : at < now.getTime();
}
export function upcoming(activities, now = new Date()) {
    return activities
        .filter((a) => !isFinished(a, now))
        .sort((a, b) => a.start.localeCompare(b.start));
}
